
























































































































































import Vue from 'vue';
import {
  booth,
  BoothListItem,
  Option,
  calender,
} from 'mostra';

const searchTypes: Option = [
  { value: 1, text: 'ブースID' },
  { value: 2, text: 'ブランドID' },
  { value: 3, text: '企業ID' },
];

export type DataType = {
  loading: boolean;
  boothList: BoothListItem[] | null;
  currentPage: number;
  perPage: number;
  searchText: string;
  searchType: number;
  searchTypes: Option;
  isSearched: boolean;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-admin-booth-index',
  data(): DataType {
    return {
      loading: true,
      boothList: null,
      currentPage: 1,
      perPage: 500,
      searchText: '',
      searchType: 1,
      searchTypes: searchTypes,
      isSearched: false,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        if (this.isSearched) {
          if (this.searchType === 2 && this.searchText) {
            this.boothList = await booth.loadBoothListByBrandId(this.searchText, this.isForced);
          }
          if (this.searchType === 3 && this.searchText) {
            this.boothList = await booth.loadBoothListByOwner(this.searchText, this.isForced);
          }
        } else {
          this.boothList = await booth.loadBoothList(this.perPage, 1, val);
        }
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatStringArray(array: string[]) {
      return array.join(' , ');
    },
    async fetchData() {
      this.loading = true;
      this.$loading(true);
      try {
        this.boothList = await booth.loadBoothList(this.perPage, 1);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.boothList = await booth.loadBoothList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickSearch() {
      this.$loading(true);
      try {
        if (this.searchType === 1 && this.searchText) {
          this.boothList = await booth.loadBoothListByBoothId(this.searchText);
          this.isSearched = true;
        }
        if (this.searchType === 2 && this.searchText) {
          this.boothList = await booth.loadBoothListByBrandId(this.searchText, this.isForced);
          this.isSearched = true;
        }
        if (this.searchType === 3 && this.searchText) {
          this.boothList = await booth.loadBoothListByOwner(this.searchText, this.isForced);
          this.isSearched = true;
        }
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async onClickReset() {
      this.$loading(true);
      try {
        this.boothList = await booth.loadBoothList(this.perPage, this.currentPage, this.isForced);
        this.isSearched = false;
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async onClickCountAllBooths() {
      this.total = await booth.countAllBooths();
    },
  },
});
